<template>
  <ul>
    <!-- MENU -->
    <template>
      <li
        v-for="(item, index) in menu"
        :key="index"
        :class="[
          item.team ? (item.team.includes(user.team_id) ? '' : 'hidden') : '',
          item.t_session
            ? item.t_session.includes(session_team_current)
              ? ''
              : 'hidden'
            : '',
        ]"
      >
        <router-link
          v-if="item.role.includes(user.role)"
          :to="item.to"
          :class="[
            classname,
            subIsActive(item.to) ? `${classname}--active` : '',
          ]"
        >
          <div :class="`${classname}__icon`">
            <app-icon :name="item.icon"></app-icon>
          </div>
          <div :class="`${classname}__title`">
            {{ item.title }}
          </div>
        </router-link>
      </li>
    </template>
  </ul>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Icon from '@/components/admin/partials/Icon'

export default {
  name: 'SideBar',
  props: ['classname'],
  data() {
    return {
      menu: [
        {
          role: [1],
          to: '/admin/dashboard',
          icon: 'home',
          title: 'Dashboard',
        },
        {
          role: [1],
          to: '/admin/traffic/tasks',
          icon: 'hard-drive',
          title: 'Trafico',
        },
        {
          role: [1, 2, 3, 4, 5],
          to: '/admin/business/budgets',
          icon: 'archive',
          title: 'Administración',
          team: [5, 9],
        },
        {
          role: [1],
          to: '/admin/users',
          icon: 'users',
          title: 'Usuarios',
        },
        {
          role: [1],
          to: '/admin/libraries',
          icon: 'libraries',
          title: 'Biblioteca',
        },
        {
          role: [1],
          to: '/admin/activities',
          icon: 'activities',
          title: 'Actividades',
        },
        {
          role: [2, 3, 4, 5],
          to: '/admin/home',
          icon: 'home',
          title: 'Dashboard',
        },
        {
          role: [2],
          to: '/admin/business/budgets',
          icon: 'archive',
          title: 'Administración',
        },
        {
          role: [2, 3, 4, 5],
          to: '/admin/tasks',
          icon: 'file-plus',
          title: 'Tareas',
        },
        {
          role: [2, 3, 4, 5],
          to: '/admin/pendings-tasks',
          icon: 'file',
          title: 'Tareas Pendientes',
        },
        {
          role: [3, 4, 5],
          to: '/admin/hours-tasks',
          icon: 'clock',
          title: 'Horas',
        },
        {
          role: [3, 4, 5],
          to: '/admin/week',
          icon: 'clock',
          title: 'Trafico',
        },
        {
          role: [3, 4, 5],
          to: '/admin/emails',
          icon: 'code',
          title: 'Cortes',
        },
        {
          role: [3, 4, 5],
          to: '/admin/pendings-emails',
          icon: 'code',
          title: 'Cortes Pendientes',
          team: [1],
        },
        {
          role: [3, 4, 5],
          to: '/admin/campaigns',
          icon: 'mail',
          title: 'Campañas',
        },
        {
          role: [3, 5],
          to: '/admin/team',
          icon: 'users',
          title: 'Equipo',
        },
        {
          role: [3, 4, 5],
          to: '/admin/planning',
          icon: 'clock',
          title: 'Planeación',
          t_session: ['2', '3'],
        },
        {
          role: [1, 2, 3, 4, 5],
          to: '/admin/platforms',
          icon: 'layers',
          title: 'Plataformas',
        },
        {
          role: [2, 3, 4, 5],
          to: '/admin/library',
          icon: 'libraries',
          title: 'Libreria',
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      session_team_current: 'getSessionTeam',
    }),
  },
  methods: {
    subIsActive(input) {
      const paths = Array.isArray(input) ? input : [input]
      return paths.some((path) => {
        return this.$route.path.indexOf(path) == 0
      })
    },
    ...mapMutations(['SESSION_ACCOUNT', 'SESSION_TEAM']),
  },

  components: {
    appIcon: Icon,
  },
}
</script>



// WEBPACK FOOTER //
// SideBar.vue?0d498bf5